export default __webpack_public_path__ + "static/media/ezyfindlogo-light.38d98a69.png";